module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/index.js
 ** module id = 314
 ** module chunks = 2
 **/